import {Key} from "../../../../typescript-plugin/entities/Key";
import {Slot} from "../calendar/Slot";
import {IEntity} from "../../../../typescript-plugin/entities/IEntity";

export class RemovedSlot implements IEntity{
    public slot:Slot;

    public unavailabilityId:string;

    public Key(): Key {
        return new Key({
            slot: this.slot.Value(),
            unavailabilityId: this.unavailabilityId
        });
    }

    public ToPersistable(): {} {
        return {
            slot: this.slot.Value(),
            unavailabilityId: this.unavailabilityId,
        };
    }

    public ToEntity(data: {}): void {
        this.slot = new Slot(data["slot"]);
        this.unavailabilityId = data["unavailabilityId"];
    }

    public Serialize(): {} {
        return {
            slot: this.slot.Value(),
            unavailabilityId: this.unavailabilityId
        };
    }

    public Deserialize(data: {}): void {
        this.slot = new Slot(data["slot"]);
        this.unavailabilityId = data["unavailabilityId"];
    }

    public AsFake():RemovedSlot{
        this.slot = new Slot("2019-05-20-AM");
        this.unavailabilityId = "unavailabilityId";
        return this;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/unaivailability/RemovedSlot.ts